export { DMS_MODULE } from '@/modules/ciselnik/constants';
export const CRUMB_LABEL_KEY = 'edtFaktProfilNdPcNahr';
export const NAME = <const>'SmluvniCenaNd';
